import { createContext, useContext, useEffect, useState } from "react";
import { LANGUAGES, translations } from "./translations";

const LanguageContext = createContext(null);

const BALKAN_LANGS = ["bs", "hr", "sr", "sl", "sq", "mk", "cnr", "me"];

const detectLanguage = () => {
  const saved = localStorage.getItem("gv-lang");
  if (saved && translations[saved]) return saved;
  const nav = (navigator.language || "fr").slice(0, 2).toLowerCase();
  if (BALKAN_LANGS.includes(nav)) return "bs";
  return translations[nav] ? nav : "fr";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(detectLanguage);
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = current.dir;
    localStorage.setItem("gv-lang", lang);
  }, [lang, current.dir]);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, dir: current.dir, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
